// src/api/ligaApi.js

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
const SERVER_BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace("/api", "")
  : "http://localhost:3001";

const getAuthHeaders = (isFormData = false) => {
  const token = localStorage.getItem("adminToken");
  const headers = {};
  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  return headers;
};

const handleResponse = async (response) => {
  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem("adminToken");
    window.location.reload();
    throw new Error(
      "Sessão inválida ou expirada. Por favor, faça login novamente."
    );
  }
  if (!response.ok) {
    const err = await response.json().catch(() => ({
      message: `Erro de Servidor: Status ${response.status}`,
    }));
    throw new Error(
      err.message || err.error || "Ocorreu um erro desconhecido."
    );
  }
  if (response.status === 204) {
    return { success: true };
  }
  return response.json().catch(() => ({ success: true }));
};

export const getEscudoUrl = (originalUrl) => {
  if (!originalUrl) return "";
  if (originalUrl.startsWith("/uploads")) {
    return `${SERVER_BASE_URL}${originalUrl}`;
  }
  return `${API_URL}/image-proxy?url=${encodeURIComponent(originalUrl)}`;
};

export const loginAdmin = async (email, password) => {
  const response = await fetch(`${API_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return handleResponse(response);
};

// --- FUNÇÕES PARA DESAFIOS ---

export const getPublicDesafios = async () => {
  const response = await fetch(`${API_URL}/public/desafios`);
  return handleResponse(response);
};

export const getDesafios = async () => {
  const response = await fetch(`${API_URL}/desafios`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const createDesafio = async (desafioData) => {
  const response = await fetch(`${API_URL}/desafios`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(desafioData),
  });
  return handleResponse(response);
};

// --- FUNÇÕES DENTRO DE UM DESAFIO ---

export const getDadosCompletosDesafio = async (id) => {
  const response = await fetch(`${API_URL}/desafio/${id}/dados-completos`);
  return handleResponse(response);
};

export const addDupla = async (nome, desafio_id) => {
  const response = await fetch(`${API_URL}/duplas`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ nome, desafio_id }),
  });
  return handleResponse(response);
};

export const removeDupla = async (id) => {
  const response = await fetch(`${API_URL}/duplas/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const addTime = async (timeData) => {
  const response = await fetch(`${API_URL}/times`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(timeData),
  });
  return handleResponse(response);
};

export const removeTime = async (id) => {
  const response = await fetch(`${API_URL}/times/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const searchCartolaTimes = async (query) => {
  if (!query) return [];
  const response = await fetch(
    `${API_URL}/cartola/search?q=${encodeURIComponent(query)}`
  );
  return handleResponse(response);
};

export const setCaptain = async (timeId, duplaId) => {
  const response = await fetch(`${API_URL}/times/${timeId}/set-captain`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify({ duplaId }),
  });
  return handleResponse(response);
};

export const uploadLogo = async (duplaId, formData) => {
  const response = await fetch(`${API_URL}/duplas/${duplaId}/logo`, {
    method: "POST",
    headers: getAuthHeaders(true),
    body: formData,
  });
  return handleResponse(response);
};

export const fetchScoresForRound = async (numero, desafio_id) => {
  const response = await fetch(`${API_URL}/rodadas/${numero}/fetch-scores`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ desafio_id }),
  });
  return handleResponse(response);
};

export const updateAllTimes = async (desafio_id) => {
  const response = await fetch(`${API_URL}/times/update-all`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify({ desafio_id }),
  });
  return handleResponse(response);
};

export const resetarPontuacoes = async (desafio_id) => {
  const response = await fetch(`${API_URL}/rodadas/reset`, {
    method: "DELETE",
    headers: getAuthHeaders(),
    body: JSON.stringify({ desafio_id }),
  });
  return handleResponse(response);
};

console.log("A API está a tentar ligar-se a:", API_URL);

export const deleteDesafio = async (id) => {
  const response = await fetch(`${API_URL}/desafios/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const resetScoresForRound = async (numero, desafio_id) => {
  const response = await fetch(`${API_URL}/rodadas/${numero}/reset`, {
    method: "DELETE",
    headers: getAuthHeaders(),
    body: JSON.stringify({ desafio_id }),
  });
  return handleResponse(response);
};
